// extracted by mini-css-extract-plugin
export default {"container":"profile_container__yPybk","TabsContent":"profile_TabsContent__+-dHO","RowTabs":"profile_RowTabs__Vypwy"};